import React, { HTMLAttributes } from 'react'
import Box from '@mui/material/Box'

type ControlBarItemProps = HTMLAttributes<HTMLDivElement> & {
  disableMargin?: boolean
}

export default function ControlBarItem(props: ControlBarItemProps) {
  const { children, disableMargin } = props
  return (
    <Box component="div" sx={{ margin: `0 ${disableMargin ? '0' : '0.25rem'}` }}>
      {children}
    </Box>
  )
}